module.exports = __webpack_public_path__ + "img/furnitureshop-banner-03.2de22d72.png";